import { render, staticRenderFns } from "./FeedProductSMSChargesTab.vue?vue&type=template&id=9e2a9ff0&"
import script from "./FeedProductSMSChargesTab.vue?vue&type=script&lang=ts&"
export * from "./FeedProductSMSChargesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports